import { render, staticRenderFns } from "./OrderKanbanTable.vue?vue&type=template&id=692c46d6&"
import script from "./OrderKanbanTable.vue?vue&type=script&lang=js&"
export * from "./OrderKanbanTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports